import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'PUBLIC_PROCEDURES_BUTTONS', {
  HOME: 'Home',
  DIVORCE: 'Divorce',
  JEWISHNESS: 'Jewishness',
  DEATH: 'Death',
  RESERVATION: 'Reservation',
  MARRIAGE: 'Marriage',
  MATZEVA: 'Matzeva',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'PUBLIC_PROCEDURES_BUTTONS', {
  HOME: 'Inicio',
  DIVORCE: 'Divorcio',
  JEWISHNESS: 'Certificado de judeidad',
  DEATH: 'Fallecimiento',
  RESERVATION: 'Reserva',
  MARRIAGE: 'Casamiento',
  MATZEVA: 'Matzeva',
});
